<template>
    <div :class="`${rowClass} h-100`">
        <div :class="`${colClass} h-100`">
            <div class="h-100">

                <b-row class="mb-2">
                    <b-col class="col-auto pr-0">
                        <b-button-group size="sm">
                            <b-button variant="outline-branded" size="sm" :disabled="busy" @click="onClickPrevious">
                                <i class="fa fa-fw fa-chevron-left"></i>
                            </b-button>
                            <b-button variant="outline-branded" size="sm" :disabled="busy" @click="onClickNext">
                                <i class="fa fa-fw fa-chevron-right"></i>
                            </b-button>
                        </b-button-group>
                    </b-col>
                    <b-col class="">
                        <date-picker v-model="date" :config="dateConfig" :disabled="busy">
                            <span class="lead d-none d-lg-inline-block">{{ dateRange }}</span>
                            <span class="d-none d-md-inline-block d-lg-none pt-1">{{ dateRange }}</span>
                            <small class="d-inline-block d-md-none pt-1">{{ dateRange }}</small>
                            <i class="fa fa-fw fa-caret-down"></i>
                        </date-picker>
                    </b-col>
                    <b-col class="col-auto pl-0">
                        <b-button-group size="sm">
                            <b-button :variant="view == 'dayGridMonth' ? 'branded' : 'outline-branded'"
                                @click="onChangeView('dayGridMonth')" :disabled="busy">
                                {{ trans('month') }}
                            </b-button>
                            <b-button :variant="view == 'timeGridWeek' ? 'branded' : 'outline-branded'"
                                @click="onChangeView('timeGridWeek')" :disabled="busy">
                                {{ trans('week') }}
                            </b-button>
                            <b-button :variant="view == 'timeGridDay' ? 'branded' : 'outline-branded'"
                                @click="onChangeView('timeGridDay')" :disabled="busy">
                                {{ trans('day') }}
                            </b-button>
                        </b-button-group>
                    </b-col>
                </b-row>

                <b-overlay :show="busy">
                    <full-calendar ref="calendar" :defaultDate="date" :defaultView="view" :views="views" :firstDay="1"
                        height="auto" :plugins="plugins" :locale="locale" themeSystem="bootstrap" :allDaySlot="false"
                        :minTime="minTime" :maxTime="maxTime" :header="false" :events="events" :eventRender="onEventRender"
                        :datesRender="onDatesRender" @eventClick="onEventClick" :selectable="isPreview" @select="onSelect"
                        @unselect="onUnselect" />
                </b-overlay>

            </div>
        </div>

    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction';
import frLocale from '@fullcalendar/core/locales/fr-ca'
import '@fullcalendar/core/main.css'
import '@fullcalendar/daygrid/main.css'
import '@fullcalendar/timegrid/main.css'
import DatePicker from './DatePicker'

export default {
    props: {
        organization: Object,
        page: Object,
        block: Object,
        events: Array,
        isPreview: {
            type: Boolean,
            default: false,
        },
        busy: Boolean,
    },
    components: {
        FullCalendar,
        DatePicker,
    },
    data() {
        return {
            trans: trans,
            error: null,
            iframeUrlPrefix: _.iframeUrlPrefix,
            locale: window.lang == 'fr' ? frLocale : undefined,
            plugins: [dayGridPlugin, timeGridPlugin, bootstrapPlugin, interactionPlugin],
            date: moment().format('YYYY-MM-DD'),
            dateConfig: {
                locale: window.lang,
                format: 'YYYY-MM-DD',
                showTodayButton: true,
            },
            start: null,
            end: null,
            view: 'timeGridWeek',
            views: {
                timeGridWeekend: {
                    type: 'timeGridWeek',
                    //duration: { days: 4 }
                    hiddenDays: [2, 3, 4],
                },
            },
            event: null,
        }
    },
    computed: {
        rowClass() {
            return 'row'
        },
        colClass() {
            return 'col-12'
        },
        dateRange() {
            let str = ''
            if (this.view.indexOf('Week') >= 0 && this.start && this.end) {
                str = _.dateRangeStr(moment(this.start), moment(this.end).add(-1, 'days'))
            }
            else if (this.view.indexOf('Month') >= 0) {
                str = moment(this.date).format('MMMM Y')
            }
            else if (this.view.indexOf('Day') >= 0) {
                str = moment(this.date).format('D MMM Y')
            }
            return str
        },
        minTime() {
            let minHour = 23
            minHour = _.reduce(this.events, (minTime, event) => {
                let date = moment(event.start)
                if (date.hour() < minHour) minHour = date.hour()
                return minHour
            }, minHour)
            minHour -= 1
            if (minHour <= 0) return '00:00:00'
            let minTime = moment()
            minTime.set({
                hour: minHour,
                minute: 0,
                second: 0
            })
            return minTime.format('HH:mm:ss')
        },
        maxTime() {
            let maxHour = 0
            maxHour = _.reduce(this.events, (maxHour, event) => {
                let start = moment(event.start)
                let hour = start.hour()
                if (start.minute() > 0) hour += 1
                if (hour > maxHour) maxHour = hour
                if (event.end) {
                    let end = moment(event.end)
                    if (end.hour() > maxHour) maxHour = end.hour()
                    if (end.hour() <= start.hour()) maxHour = 24
                }
                return maxHour
            }, maxHour)
            maxHour += 1
            if (maxHour >= 24) return '24:00:00'
            let maxTime = moment()
            maxTime.set({
                hour: maxHour,
                minute: 0,
                second: 0
            })
            return maxTime.format('HH:mm:ss')
        },
    },
    watch: {
        block() {
            /*this.view = this.block.meta.view
            this.date = moment(this.block.meta.date || undefined).format('YYYY-MM-DD')
            if (this.$refs.calendar) {
              this.$refs.calendar.getApi().changeView(this.view)
              this.$refs.calendar.getApi().gotoDate(this.date)
              this.$refs.calendar.getApi().refetchEvents()
            }*/
        },
        date() {
            this.$emit('date', this.date)
            if (this.date == moment(this.$refs.calendar.getApi().getDate()).format('YYYY-MM-DD')) return
            if (this.start && this.date == moment(this.start).format('YYYY-MM-DD')) return
            this.$refs.calendar.getApi().gotoDate(this.date)
        },
    },
    methods: {
        onClickNext() {
            this.$refs.calendar.getApi().next()
            this.date = moment(this.$refs.calendar.getApi().getDate()).format('YYYY-MM-DD')
        },
        onClickPrevious() {
            this.$refs.calendar.getApi().prev()
            this.date = moment(this.$refs.calendar.getApi().getDate()).format('YYYY-MM-DD')
        },
        onChangeView(view) {
            this.view = view
            this.$refs.calendar.getApi().changeView(this.view)
            this.$emit('view', view)
        },
        onDatesRender() {
            this.date = moment(this.$refs.calendar.getApi().getDate()).format('YYYY-MM-DD')
            this.start = this.$refs.calendar.getApi().view.activeStart
            this.end = this.$refs.calendar.getApi().view.activeEnd

            this.$emit('date', this.date)
        },
        onEventRender(info) {
            let icon = ''
            let badge = ''
            if (info.event.extendedProps.type == 'request') icon = '<i class="fa fa-question-circle"></i> '
            if (info.event.extendedProps.type == 'event') icon = '<i class="fa fa-birthday-cake"></i> '
            if (info.event.extendedProps.booking_status == 'paid') {
                icon = '<i class="fa fa-file-invoice-dollar"></i> '
                badge = `<small><sup class="badge badge-success">${trans('paid')}</sup></small>`
            }
            if (info.event.extendedProps.booking_status == 'not_paid') {
                icon = '<i class="fa fa-file-invoice-dollar"></i> '
                badge = `<small><sup class="badge badge-danger">${trans('not_paid')}</sup></small>`
            }
            if (info.event.extendedProps.booking_status == 'cart') icon = '<i class="fa fa-shopping-cart"></i> '
            if (info.event.extendedProps.booking_status == 'new') icon = '<i class="fa fa-chalkboard-teacher"></i> '
            let title = `<div class="fc-title font-weight-bold">${icon}${info.event.title}${badge}</div>`

            let type = `<div><span class="badge badge-light" style="background-color:${info.event.borderColor};">${info.event.extendedProps.type}</span></div>`
            let activity = info.event.extendedProps.activity ? `<div class="mt-1"><i class="fa fa-fw fa-futbol"></i> ${info.event.extendedProps.activity}</div>` : null
            let client = info.event.extendedProps.client ? `<div class="mt-1"><i class="fa fa-fw fa-user"></i> ${info.event.extendedProps.client}</div>` : null
            let location = info.event.extendedProps.location ? `<div class="mt-1"><i class="fa fa-fw fa-map-marker-alt"></i> ${info.event.extendedProps.location}</div>` : null
            let locationNoAddress = info.event.extendedProps.location ? `<div class="mt-1"><i class="fa fa-fw fa-map-marker-alt"></i> ${info.event.extendedProps.location.split('|')[0]}</div>` : null
            let deletedAt = info.event.extendedProps.deleted ? `<div class="mt-1">(${trans('cancelled')})</div>` : null

            if (info.event.extendedProps.maximum_attendance) {
                let text = info.event.extendedProps.maximum_attendance
                if (info.event.extendedProps.reserved) {
                    text = info.event.extendedProps.reserved + '/' + text + ' ' + trans('participant' + (info.event.extendedProps.reserved > 1 ? 's' : '')).toLowerCase()
                } else {
                    text += ' ' + trans('remaining_spots').toLowerCase()
                }
                activity = `<div class="mt-1">${text}</div>`
            }

            info.el.querySelector('.fc-title').outerHTML = _.compact([title, activity, client, locationNoAddress]).join('')

            // Swap the order
            info.el.querySelector('.fc-content').insertBefore(info.el.querySelector('.fc-title'), info.el.querySelector('.fc-time'))

            let time = `<div class="fc-time"><span>${moment(info.event.start).format('LT')} ${info.event.end ? (' - ' + moment(info.event.end).format('LT')) : ''}</span></div>`

            $(info.el).popover({
                title: `${icon}${info.event.title}${badge}`,
                content: _.compact([time, activity, client, location, deletedAt]).join(''),
                html: true,
                placement: 'auto',
                boundary: 'scrollParent',
                boundaryPadding: 5,
                delay: 1000,
                offset: 0,
                trigger: 'hover',
            })
        },
        onEventClick(e) {
            e.el.focus() // Fix for https://github.com/fullcalendar/fullcalendar/issues/3364
            if (!e.url) e.jsEvent.preventDefault()
            let event = e.event
            this.$emit('click', event)
            /*    let event = e.event
                if (this.isPreview) {

                } else if (event.extendedProps.type == 'am_class' && event.extendedProps.form_url) {
                    window.formIframeModalUpid = _.extractUpidFromUrl(event.extendedProps.form_url)
                    //this.$bvModal.show('form-iframe-modal')
                } else {
                    //let id = parseInt(event.event.id, 10)
                    //this.event = _.find(this.events, {id: id})
                    this.event = event
                    //this.$bvModal.show('page-calendar-event-modal')
                }*/
        },
        onSelect(info) {
            this.$emit('select', info)
        },
        onUnselect(info) {
            this.$emit('unselect', info)
        },
    },
}
</script>
